import TokenRefresher from './TokenRefresher'

// One refresher for the page, so that everything asking for a fresh token
// shares the same in-flight request.
export default new TokenRefresher()
